module.exports = __webpack_public_path__ + "static/audit-4a777ce07a909f2f2796af9776115483.jpg";